export const SITE = {
  agentName: "Muhammad Firdaus Md Noor",
  agency: "dausREALTY",
  role: "Perunding Hartanah (REN)",
  phoneDisplay: "011-1639 4909",
  phoneRaw: "601116394909",
  whatsappMsg: "Salam, saya berminat untuk semak kelayakan pinjaman perumahan.",
  photo:
    "https://customer-assets.emergentagent.com/job_loan-guide-my/artifacts/pgdtl63z_baa6a6d9-355e-4033-a538-a30b54ee3077.jpg",
  facebookUrl: "https://www.facebook.com/firdaus.hartanah.2024",
  images: {
    house:
      "https://images.unsplash.com/photo-1760104176110-abfb35d749df?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBob3VzZSUyMGV4dGVyaW9yJTIwbWFsYXlzaWF8ZW58MHx8fHwxNzgzNTMzNzgzfDA&ixlib=rb-4.1.0&q=85",
    keys:
      "https://images.unsplash.com/photo-1741156386380-0236c72eb6f9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxmYW1pbHklMjByZWNlaXZpbmclMjBob3VzZSUyMGtleXN8ZW58MHx8fHwxNzgzNTMzNzgzfDA&ixlib=rb-4.1.0&q=85",
    skyline:
      "https://images.unsplash.com/photo-1574218732130-6b19257fd9db?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxrdWFsYSUyMGx1bXB1ciUyMHNreWxpbmV8ZW58MHx8fHwxNzgzNTMzNzgzfDA&ixlib=rb-4.1.0&q=85",
  },
};

export const waLink = () =>
  `https://wa.me/${SITE.phoneRaw}?text=${encodeURIComponent(SITE.whatsappMsg)}`;

export const waLinkWith = (msg) =>
  `https://wa.me/${SITE.phoneRaw}?text=${encodeURIComponent(msg)}`;

export const formatPrice = (raw) => {
  if (!raw) return "";
  const n = String(raw).replace(/[^0-9]/g, "");
  if (!n) return String(raw);
  return Number(n).toLocaleString("en-MY");
};

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
